<fieldset [style.display]="inline ? 'inline-block' : 'block'">
    <legend *ngIf="legend && legend.length > 0">{{ legend }}</legend>
    <ng-content></ng-content>
</fieldset>
